<section class="flex-container login">
  <div class="col-50 cover cover-admin"></div>
  <div class="col-50 center content">
    <div class="center login-form">
      <a routerLink="/">
        <img src="assets/img/logo.webp" alt="Deluxy" class="logo">
      </a>
      <br>
      <span class="riga"></span>
      <h3>Rispedisci link d'attivazione</h3>
      <form id="sendForm" #sendForm="ngForm" (ngSubmit)="resend()">
        <input type="email" [(ngModel)]="loginDTO.email" name="email" placeholder="La tua email" required>

        <button class="btn hvr-shrink" type="submit">Invia<i class="ml-10 fas fa-arrow-right"></i></button>
      </form>
    </div>
  </div>
</section>
